__turbopack_context__.v({
  "frame": "HYEgOa_frame",
  "placeholder": "HYEgOa_placeholder",
  "placeholderImage": "HYEgOa_placeholderImage",
  "root": "HYEgOa_root",
});
